{
  "version": 1,
  "asset_id": "2ca1a710-ffbd-45b0-9cd3-9b6a0d2d6cfa",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/2ca1a710-ffbd-45b0-9cd3-9b6a0d2d6cfa/plumbing-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/2ca1a710-ffbd-45b0-9cd3-9b6a0d2d6cfa/plumbing-hero.webp",
  "original_filename": "plumbing-hero.webp",
  "size": 20982,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:22Z"
}
